import React, { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

const isTokenValid = () => {
    const token = localStorage.getItem('token');
    if (!token) return false;

    try {
        const payload = JSON.parse(atob(token.split('.')[1]));
        const currentTime = Math.floor(Date.now() / 1000);
        return payload.exp > currentTime;
    } catch (e) {
        return false;
    }
};

const ProtectedRoute = ({ children }) => {
    const location = useLocation();
    const [showPopup, setShowPopup] = useState(false);
    const [redirect, setRedirect] = useState(false);
    const [countdown, setCountdown] = useState(15);
    const isLoginPage = location.pathname === '/Login';

    useEffect(() => {
        // Skip protection for login page
        if (isLoginPage) return;

        if (!isTokenValid()) {
            setShowPopup(true);

            const interval = setInterval(() => {
                setCountdown(prev => {
                    if (prev <= 1) {
                        clearInterval(interval);
                        setRedirect(true);
                        return 0;
                    }
                    return prev - 1;
                });
            }, 1000);

            return () => clearInterval(interval);
        }
    }, [isLoginPage]);

    const handleLoginRedirect = () => setRedirect(true);

    if (redirect) {
        localStorage.removeItem('token'); // Clear invalid token
        return <Navigate to="/Login" state={{ from: location }} replace />;
    }

    // Don't show popup on login page
    if (showPopup && !isLoginPage) {
        return (
            <div style={popupStyle}>
                <div style={popupContentStyle}>
                    <p style={{ margin: '0 0 10px' }}>⚠️ Session expired. Please login again.</p>
                    <button onClick={handleLoginRedirect} style={buttonStyle}>
                        Go to Login
                    </button>
                    <p style={{ fontSize: '12px', marginTop: '10px', color: '#666' }}>
                        Redirecting in {countdown} second{countdown !== 1 ? 's' : ''}...
                    </p>
                </div>
            </div>
        );
    }

    // Allow access to login page without protection
    if (isLoginPage) {
        return children;
    }

    // For protected routes, only allow access with valid token
    return isTokenValid() ? children : null;
};

export default ProtectedRoute;

// Styles remain the same
const popupStyle = {
    position: 'fixed',
    top: 0,
    left: 0,
    height: '100vh',
    width: '100vw',
    backgroundColor: 'rgba(0,0,0,0.4)',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 1000,
};

const popupContentStyle = {
    backgroundColor: '#fff',
    padding: '20px 30px',
    borderRadius: '8px',
    fontSize: '16px',
    textAlign: 'center',
    boxShadow: '0 0 10px rgba(0,0,0,0.2)',
};

const buttonStyle = {
    padding: '8px 16px',
    backgroundColor: '#0D2B52',
    color: '#fff',
    border: 'none',
    borderRadius: '4px',
    cursor: 'pointer',
    fontSize: '14px',
};